import type { FC, ReactNode } from 'react'
import React, { useState } from 'react'
import clsx from 'clsx'
import { makeStyles, createStyles, withStyles } from '@material-ui/core/styles'
import Tooltip from '@material-ui/core/Tooltip'
import IconButton from '@material-ui/core/IconButton'
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined'
import InfoIcon from '@material-ui/icons/Info'

import { Typography } from '@homeviews/shared-ui'

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      display: 'flex',
      justifyContent: 'center',
      flexWrap: 'wrap',
    },
    button: {
      padding: 0,
      '&:hover': {
        backgroundColor: 'transparent!important',
      },
    },
    title: {
      color: '#000433',
      marginBottom: 10,
    },
    text: {
      color: '#000433',
    },
    icon: {
      color: '#000433',
    },
  }),
)

interface IProps {
  title?: string
  text?: string
  content?: ReactNode
  layout?: 'default' | 'dark' | 'light'
  borderRadiusPx?: number
  maxWidthPx?: number
  noArrow?: boolean
}

const CustomTooltip: FC<IProps> = ({
  title,
  text,
  content,
  borderRadiusPx = 3,
  maxWidthPx = 288,
  noArrow = false,
}) => {
  const [isOpen, setIsOpen] = useState<boolean>(false)
  const classes = useStyles()

  const handleOpen = () => {
    setIsOpen(true)
  }

  const handleClose = () => {
    setIsOpen(false)
  }

  const TooltipWrapper = withStyles((theme) => {
    return {
      tooltip: {
        maxWidth: maxWidthPx,
        transform: 'translateX(-15px)!important',
        padding: 20,
        borderRadius: borderRadiusPx,
        border: `1px solid ${theme.colors.grey600}`,
        backgroundColor: '#fff !important',
        color: theme.colors.grey800,
        fontSize: theme.typography.pxToRem(14),
      },
      arrow: {
        transform: 'scale(1.5)',
        top: '-1px!important',
        left: '15px!important',
        color: '#fff !important',
      },
    }
  })(Tooltip)

  return (
    <TooltipWrapper
      title={
        content ? (
          content
        ) : (
          <div>
            {title && (
              <Typography variant="h3" className={classes.title}>
                {title}
              </Typography>
            )}
            <Typography className={classes.text}>{text}</Typography>
          </div>
        )
      }
      arrow={noArrow ? false : true}
      placement="bottom-start"
      onOpen={handleOpen}
      onClose={handleClose}
      interactive
    >
      <IconButton
        aria-label="info"
        className={clsx('c-tooltip', 'c-tooltip--info', classes.button)}
      >
        {isOpen ? (
          <InfoIcon className={clsx('c-tooltip__icon', classes.icon)} />
        ) : (
          <InfoOutlinedIcon className={clsx('c-tooltip__icon', classes.icon)} />
        )}
      </IconButton>
    </TooltipWrapper>
  )
}

export default CustomTooltip
